import React, { ReactNode } from "react";
import "../../styles/typography.css";

interface SectionTitleProps {
    children: ReactNode;
}

const SectionTitle:React.FC<SectionTitleProps> = ({ children }) => {
    return (
        <h3 className="section-title">
            {children}
        </h3>
    )
}

export default SectionTitle;